import { render, staticRenderFns } from "./SoftSkillMultiselectItem.vue?vue&type=template&id=00c64d64"
import script from "./SoftSkillMultiselectItem.vue?vue&type=script&lang=ts"
export * from "./SoftSkillMultiselectItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c64d64')) {
      api.createRecord('00c64d64', component.options)
    } else {
      api.reload('00c64d64', component.options)
    }
    module.hot.accept("./SoftSkillMultiselectItem.vue?vue&type=template&id=00c64d64", function () {
      api.rerender('00c64d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skills/SoftSkillMultiselectItem.vue"
export default component.exports